export default "__VITE_PUBLIC_ASSET__461a99ec__"